import UnitMinimal from '@interfaces/Unit/UnitMinimal';

const unitHasOpenTimeConfig = (unit: UnitMinimal) => unit.openTimeConfig === true;

export default unitHasOpenTimeConfig;
